"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _BoxStyles.Box;
  }
});

var _BoxStyles = require("./Box-styles");